module.exports = __webpack_public_path__ + "static/lframe-business-if-aa837eed0964b82cff2ff32a10944872.png";